import { GHID, STRATEGICAL, /* GGML */ } from './authorization';

export const rainHistoricChartAuthorization = [ GHID ];
export const rainAndFlowChartAuthorization = [ GHID, STRATEGICAL, /* GGML */ ];
export const permanenceChartAuthorization = [ GHID ];
export const usefulVolumeChartAuthorization = [ GHID ];
export const usefulVolumePercentageChartAuthorization = [ GHID ];
export const usefulVolumeAreaChartAuthorization = [ GHID ];
export const levelUnderSpillwayChartAuthorization = [ GHID ];
export const reservoirSupplyChartAuthorization = [ GHID ];
export const currentDemandChartAuthorization = [ GHID ];
export const suppliedInhabitantsChartAuthorization = [ GHID ];
export const HistoricalDataConservationHectareChartAuthorization = [ GHID ];
export const HistoricalDataConservationPercentageChartAuthorization = [ GHID ];
export const chartStationsData = [ GHID ];
export const tableStationsData = [ GHID ];
export const EvolutionHectareChartAuthorization = [ GHID ];
export const EvolutionPercentageChartAuthorization = [ GHID ];
export const dailyMeteorologicalChartAuthorization = [ GHID ];
export const todayMeteorologicalChartAuthorization = [ GHID ];
export const tomorrowMeteorologicalChartAuthorization = [ GHID ];
export const rainEstimationHistoricalDataAuthorization = [GHID];
export const tableBasinsData = [GHID];
